// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"7a52063e","796":"156b413c"}[chunkId] + ".chunk.js";
};